import CircleIcon from '@mui/icons-material/Circle';
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useActivateQuery } from '@/models/auth';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

export const Activate = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const { isLoading, isError, isSuccess, error } = useActivateQuery(
    token ? token : '',
    { skip: !token }
  );

  return (
    <div className="w-98 p-2 grid justify-center items-center mb-32">
      {isLoading && <CircularProgress className="mx-auto mt-12" />}

      {isError && (
        <div className="mx-auto mt-12 flex items-center justify-center">
          <CircleIcon style={{ fontSize: 60 }} color="error" />
          <h3 className="font-semi-bold text-2xl ml-3">
            {error && 'status' in error && (error.data as any).message}!
          </h3>
        </div>
      )}

      {isSuccess && (
        <>
          <div className="mx-auto my-12 flex items-center justify-center">
            <h3 className="font-semi-bold text-2xl ml-3">
              {t('auth.activate.activated')}
            </h3>
          </div>
          <Button
            color="success"
            variant="contained"
            onClick={() => navigate('/login')}
          >
            {t('auth.login.form.login')}
          </Button>
        </>
      )}
    </div>
  );
};
